import taxi from "../assets/Taxi.svg";
import bike from "../assets/bike.svg";
import cargo from "../assets/Pickup-new.png";
import food from "../assets/food.svg";
import market from "../assets/market.svg";
import experss from "../assets/market (1).svg";
import ticket from "../assets/ticket-icon.svg";
import doctor from "../assets/doctor.svg";
import hotel from "../assets/hotel.png";
import tripout from "../assets/trip.svg";
import shop from "../assets/new Shop.png";
import bus from "../assets/bus.png";
import train from "../assets/train.png";
import club from "../assets/club.svg";
import bors from "../assets/Service Icon.png";
import sevicebus from "../assets/Moving.png";
import pay from "../assets/pay.svg";
import snappticket from "../assets/ticket-icon.svg";
import income1 from "../assets/income1.png";
import income2 from "../assets/income2.png";
import income3 from "../assets/income3.png";
import income4 from "../assets/income4.png";
import bakery from "../assets/bakery.png";
import icecream from "../assets/icecream.png";
import cafe2 from "../assets/cafe2.png";
import sweets from "../assets/sweets.png";
import restaurant from "../assets/restaurant.png";
import protein2 from "../assets/protein2.png";
import nuts from "../assets/nuts.png";
import fruit from "../assets/fruit.png";
import irani from "../assets/irani.jpeg";
import fastfood from "../assets/fastfood.jpeg";
import kabab from "../assets/kabab.jpeg";
import pitza from "../assets/pitza.jpeg";
import burger from "../assets/burger.jpeg";
import sandwich from "../assets/sandwich.jpeg";
import fry from "../assets/fry.jpeg";
import pasta from "../assets/pasta.jpeg";
import salad from "../assets/salad.jpeg";
import sea from "../assets/sea.jpeg";
import intl from "../assets/sea.jpeg";
import gilaki from "../assets/gilaki.jpeg";
import experss_1 from "../assets/experss-1.jpeg";
import experss_2 from "../assets/experss-2.jpeg";
import experss_3 from "../assets/experss-3.jpeg";
import experss_4 from "../assets/experss-4.jpeg";
import experss_5 from "../assets/experss-5.jpeg";
import experss_6 from "../assets/experss-6.jpeg";
import experss_7 from "../assets/experss-7.jpeg";
import experss_8 from "../assets/experss-8.jpeg";
import experss_9 from "../assets/experss-9.jpeg";
import experss_10 from "../assets/experss-10.jpeg";
import experss_11 from "../assets/experss-11.jpeg";
import experss_12 from "../assets/experss-12.jpeg";
// export const datahome = [
//   {
//     id: 1,
//     img: taxi,
//     title: "تاکسی اینترنتی",
//     detail: "امکان درخواست آنلاین خودرو",
//   },
//   {
//     id: 2,
//     img: bike,
//     title: " پیک موتوری",
//     detail: "حمل و نقل با اسنپ",
//   },
//   {
//     id: 3,
//     img: cargo,
//     title: "درخواست وانت",
//     detail: "حمل و نقل با اسنپ",
//   },
//   {
//     id: 4,
//     img: food,
//     title: "سفارش آنلاین غذا",
//     detail: "سفارش غذا،نان و شیرینی با اسنپ",
//   },
//   {
//     id: 5,
//     img: market,
//     title: "سوپر مارکت آنلاین",
//     detail: "تهیه اقلام روزانه با اسنپ",
//   },
//   {
//     id: 6,
//     img: experss,
//     title: "اسنپ اکسپرس",
//     detail: "تحویل کمتر از 30 دقیقه",
//   },
//   {
//     id: 7,
//     img: ticket,
//     title: "بلیط پرواز داخلی ",
//     detail: "گردشگری با اسنپ ",
//   },
//   {
//     id: 8,
//     img: ticket,
//     title: "بلیط پرواز خارجی ",
//     detail: "گردشگری با اسنپ ",
//   },
//   {
//     id: 9,
//     img: doctor,
//     title: "دکتر ",
//     detail: "درمان با اسنپ ",
//   },
//   {
//     id: 10,
//     img: hotel,
//     title: "رزرو هتل ",
//     detail: "گردشگری با اسنپ ",
//   },
//   {
//     id: 11,
//     img: tripout,
//     title: "رزرو اقامتگاه ",
//     detail: "گردشگری با اسنپ ",
//   },
//   {
//     id: 12,
//     img: shop,
//     title: "فروشگاه ",
//     detail: "خرید از فروشگاه های معتبر شهر ",
//   },
//   {
//     id: 13,
//     img: bus,
//     title: "بلیط اتوبوس",
//     detail: "گردشگری با اسنپ ",
//   },
//   {
//     id: 14,
//     img: train,
//     title: "بلیط قطار ",
//     detail: "گردشگری با اسنپ ",
//   },
//   {
//     id: 15,
//     img: club,
//     title: "اسنپ ! کلاب ",
//     detail: "باشگاه مشتریان اسنپ !",
//   },
//   {
//     id: 16,
//     img: bors,
//     title: "سرمایه گذاری ",
//     detail: "خدمات غیرحضوری بورس و سرمایه گذاری ",
//   },
//   {
//     id: 17,
//     img: sevicebus,
//     title: "اسباب کشی منزل ",
//     detail: "حمل و نقل با اسنپ ",
//   },
//   {
//     id: 18,
//     img: pay,
//     title: "سرویس اعتباری ",
//     detail: "پرداخت با اسنپ ",
//   },
//   {
//     id: 19,
//     img: snappticket,
//     title: "اسنپ تیکت ",
//     detail: "خرید آنلاین بلیط با اسنپ ",
//   },
// ];

export const access = [
  {
    id: 1,
    img: income1,
    title: " درآمد تضمینی + پاداش‌های ماهانه و هفتگی",
    detail:
      "با فعالیت در ناوگان اسنپ، علاوه بر کسب درآمد مستمر و امکان تسویه در لحظه می‌توانید با شرکت در طرح‌های تشویقی مختلف، درآمد خود را افزایش دهید.",
  },
  {
    id: 2,
    img: income2,
    title: "ساعت کاری دلخواه",
    detail:
      "فعالیت در ناوگان اسنپ محدودیت زمانی ندارد و می‌توانید فعالیت خود را در هر ساعت از شبانه‌روز و متناسب با برنامه‌ی زندگی‌تان شخصی‌سازی کنید.",
  },
  {
    id: 3,
    img: income3,
    title: "مزایا و خدمات باشگاه رانندگان",
    detail:
      "  در باشگاه رانندگان اسنپ می‌توانید از تسهیلات و خدمات متنوعی از جمله خدمات خودرویی، خدمات درمانی و همچنین خدمات رفاهی و آموزشی بهره‌مند شوید.",
  },
  {
    id: 4,
    img: income4,
    title: "کار‌فیکس",
    detail:
      " باشگاه رانندگان اسنپ به‌تازگی سرویس جدید «اسنپ کارفیکس» را برای سهولت دسترسی کاربران راننده به انواع خدمات خودرویی راه‌اندازی کرده است.",
  },
];

export const groupings = [
  {
    id: 1,
    img: bakery,
    name: "نانوایی",
    pathname: "/homeApp/food/bakery",
  },
  {
    id: 2,
    img: icecream,
    name: "آبمیوه و بستنی",
    pathname: "/homeApp/food",
  },
  {
    id: 3,
    img: cafe2,
    name: "کافه",
    pathname: "/homeApp/food",
  },
  {
    id: 4,
    img: sweets,
    name: "شیرینی",
    pathname: "/homeApp/food",
  },
  {
    id: 5,
    img: restaurant,
    name: "رستوران",
    pathname: "/homeApp/food",
  },
  {
    id: 6,
    img: protein2,
    name: "پروتیین",
    pathname: "/homeApp/food",
  },
  {
    id: 7,
    img: nuts,
    name: "آجیل",
    pathname: "/homeApp/food",
  },
  {
    id: 8,
    img: fruit,
    name: "میوه",
    pathname: "/homeApp/food",
  },
];

export const tfoods = [
  {
    id: 1,
    name: "ایرانی",
    img: irani,
    pathname: "/homeApp/food/grouping",
  },
  {
    id: 2,
    name: "فست فود",
    img: fastfood,
    pathname: "/homeApp/food/grouping",
  },
  {
    id: 3,
    name: "کباب",
    img: kabab,
    pathname: "/homeApp/food/grouping",
  },
  {
    id: 4,
    name: "پیتزا",
    img: pitza,
    pathname: "/homeApp/food/grouping",
  },
  {
    id: 5,
    name: "برگر",
    img: burger,
    pathname: "/homeApp/food/grouping",
  },
  {
    id: 6,
    name: "ساندویچ",
    img: sandwich,
    pathname: "/homeApp/food/grouping",
  },
  {
    id: 7,
    name: "سوخاری",
    img: fry,
    pathname: "/homeApp/food/grouping",
  },
  {
    id: 8,
    name: "پاستا",
    img: pasta,
    pathname: "/homeApp/food/grouping",
  },
  {
    id: 9,
    name: "سالاد",
    img: salad,
    pathname: "/homeApp/food/grouping",
  },
  {
    id: 10,
    name: "دریایی",
    img: sea,
    pathname: "/homeApp/food/grouping",
  },
  {
    id: 11,
    name: "بین الملی",
    img: intl,
    pathname: "/homeApp/food/grouping",
  },
  {
    id: 12,
    name: "گیلانی",
    img: gilaki,
    pathname: "/homeApp/food/grouping",
  },
];

export const Experss = [
  {
    id: "1",
    name: "تنقلات",
    img: experss_1,
    pathname: "",
  },
  {
    id: "2",
    name: "لبنیات و بستنی",
    img: experss_2,
    pathname: "",
  },
  {
    id: "3",
    name: "نوشیدنی",
    img: experss_3,
    pathname: "",
  },
  {
    id: "4",
    name: "خواروبار و انواع نان",
    img: experss_4,
    pathname: "",
  },
  {
    id: "5",
    name: "آرایشی و بهداشتی",
    img: experss_5,
    pathname: "",
  },
  {
    id: "6",
    name: "کنسرو و غذای آماده",
    img: experss_6,
    pathname: "",
  },
  {
    id: "7",
    name: "پروتیٔن و تخم مرغ",
    img: experss_7,
    pathname: "",
  },
  {
    id: "8",
    name: "خانه وآشپزخانه",
    img: experss_8,
    pathname: "",
  },
  {
    id: "9",
    name: "چاشنی و مواد افزودنی غذا",
    img: experss_9,
    pathname: "",
  },
  {
    id: "10",
    name: "شیرینی و دسر",
    img: experss_10,
    pathname: "",
  },
  {
    id: "11",
    name: "آجیل و خشکبار",
    img: experss_11,
    pathname: "",
  },
  {
    id: "12",
    name: "اداری و نوشت افزار",
    img: experss_12,
    pathname: "",
  },
];
